import { useState } from 'react';
import useLocalStorageState from 'js/hooks/use-local-storage-state';
import { serializeWithTimestamp, deserializeWithTimestamp } from 'js/utils/local-storage';

import MessageGlobal from 'components/message-global/MessageGlobal';

import { IMessageCarousel } from 'source/NFR.types';

const MessageCarousel: React.FC<IMessageCarousel> = ({ messageGlobals, initiallyOpen = false }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isOpen, setIsOpen] = useLocalStorageState(
    (messageGlobals?.length && messageGlobals[0]?.id) || '',
    initiallyOpen,
    {
      serialize: serializeWithTimestamp,
      deserialize: deserializeWithTimestamp
    }
  );

  const updateIsOpen = (isOpen: boolean) => {
    setIsOpen(isOpen);

    if (!isOpen) {
      setTimeout(() => setActiveIndex(0), 300);
    }
  };

  return (
    <div className="message-carousel" style={{ width: `${messageGlobals?.length * 100}%` }}>
      {messageGlobals?.map((messageGlobal, index) => (
        <MessageGlobal
          key={`${messageGlobal.id}-${index}`}
          id={messageGlobal.id}
          title={messageGlobal.title}
          message={messageGlobal.message}
          labels={messageGlobal.labels}
          theme={messageGlobal.theme}
          index={index}
          length={messageGlobals.length}
          setActiveIndex={setActiveIndex}
          activeIndex={activeIndex}
          setIsOpen={updateIsOpen}
          isOpen={isOpen}
        />
      ))}
    </div>
  );
};

MessageCarousel.displayName = 'MessageCarousel';

export default MessageCarousel;
